import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { Text } from '@beef/ui-kit';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const ProgressBar = ({ percent = 0, bg, legend }) => (
  <div className={cx('wrap')}>
    {legend && (
      <div className={cx('legend')}>
        <Text size="size6-m">{legend}</Text>
      </div>
    )}
    <div className={cx('progress-ctn')}>
      <div
        className={cx('progress', { [`progress--${bg}`]: bg })}
        style={{
          width: `${parseInt(percent, 10)}%`,
        }}
      />
    </div>
  </div>
);

ProgressBar.propTypes = {
  percent: PropTypes.number,
  bg: PropTypes.string,
  legend: PropTypes.string,
};

export default ProgressBar;
